import api from ".";

import { IProvince } from "../types/provinces";

import cookiesModifier from "../utils/cookies";

export const getProvinces = async (): Promise<IProvince[]> => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`provinces`);
        return res?.data?.data?.length > 0 ? res.data.data : [];
    } catch (error) {
        throw error;
    };
};